import { capitalize } from '../../capitalize'
import {
  trackingAllowed,
  analyticsAvailable,
  PAGE_TRACKING_STORAGE_KEY as STORAGE_KEY,
  PAGE_SOURCE_TRACKING_STORAGE_KEY,
  identifier,
} from '../'
import { setItem } from '../storage'
import { PAGE_SOURCE } from '../../../lib/tracking-events'
import { track } from '../track'
import { execute, hasFeature } from '~/utils/nativeBridge'
import { parse } from 'querystringify'

export function getViewportInfo() {
  return {
    isMobileWeb:
      typeof document !== 'undefined' && document.body && document.body.clientWidth < 1024,
    isDesktop:
      typeof document !== 'undefined' && document.body && document.body.clientWidth >= 1024,
  }
}

export const page = async pathWithSearch => {
  const handle = capitalize(pathWithSearch.split('?')[0].split('/')[1] || 'home').replace(/-/g, ' ')
  const [path] = pathWithSearch.split('?')
  const payload = { path, ...getViewportInfo() }

  const hasNativeFeature = await hasFeature('canTrackSegmentPageview')

  if (hasNativeFeature) {
    return execute('trackSegmentPageview', {
      category: handle,
      isFromWebView: true,
      ...payload,
    })
  }

  if (trackingAllowed() && analyticsAvailable()) {
    global.analytics.page(handle, { ...payload, ...identifier })
  } else {
    setItem(STORAGE_KEY, { handle, payload })
  }
}

// This is to better understand session-based referrer-data. Visit
// https://ticketswap.atlassian.net/browse/TTN-1518 for more information.
export function pageSource(pathWithSearch = '') {
  // Exit if no sessionStorage
  if (typeof sessionStorage === 'undefined') return false
  // Exit if we’ve already tracked this session
  if (sessionStorage.getItem(PAGE_SOURCE_TRACKING_STORAGE_KEY)) return false
  // Set flag in session-storage
  sessionStorage.setItem(PAGE_SOURCE_TRACKING_STORAGE_KEY, true)
  // Track source

  const [path, query] = pathWithSearch.split('?')

  const { utm_campaign, utm_medium, utm_source, utm_term, utm_content } = parse(query)
  const campaign = {
    name: utm_campaign,
    medium: utm_medium,
    source: utm_source,
    term: utm_term,
    content: utm_content,
  }
  return track(PAGE_SOURCE, { ...getViewportInfo(), path, campaign })
}
